import { connect } from 'react-redux';
import Header from '../../components/Header/Header';

const mapStateToProps = state => ({
  loggedIn: state.myAccount.loggedIn
});

const HeaderContainer = connect(mapStateToProps)(Header);

export default HeaderContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/HeaderContainer.js
 **/